import React from "react";
import { NavLink } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import DraftsIcon from "@mui/icons-material/Drafts";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WorkIcon from "@mui/icons-material/Work";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { useAuth } from "../../hooks/useAuth";

import "./DashboardLinks.css";
const DashboardLinks = ({ isSideBarExpanded, ...props }) => {

  const { user } = useAuth();
  return (
    <div className="dashboard-links">
      {/* Side Bar Activity */}
      <div className="dashboard-links-section">
        {isSideBarExpanded && (
          <h2 className="dashboard-links-section-title">ACTIVITY</h2>
        )}

        {/* Open Positions */}
        <NavLink to="/dashboard" className="dashboard-links-section-item">
          <div className="dashboard-links-icon-container">
            <WorkIcon className="dashboard-links-icon" />
          </div>
          {isSideBarExpanded && <span>Open Positions</span>}
        </NavLink>

        {/* Manual Trade */}
        <NavLink to="/manualtrades" className="dashboard-links-section-item">
          <div className="dashboard-links-icon-container">
            <ShoppingCartIcon className="dashboard-links-icon" />
          </div>
          {isSideBarExpanded && <span>Manual Trade</span>}
        </NavLink>

        {/* Trade History */}
        <NavLink to="/history" className="dashboard-links-section-item">
          <div className="dashboard-links-icon-container">
            <CalendarMonthIcon className="dashboard-links-icon" />
          </div>
          {isSideBarExpanded && <span>Trade History</span>}
        </NavLink>
      </div>
      {/* Sidebar Settings */}
      <div className="dashboard-links-section">
        {isSideBarExpanded && (
          <h2 className="dashboard-links-section-title">SETTINGS</h2>
        )}
        {/* Webhook URL */}

        <NavLink to="/webhook" className="dashboard-links-section-item">
          <div className="dashboard-links-icon-container">
            <SettingsIcon className="dashboard-links-icon" />
          </div>
          {isSideBarExpanded && <span>Webhook URL</span>}
        </NavLink>

        {/* Account Info */}
        <NavLink to="/account" className="dashboard-links-section-item">
          <div className="dashboard-links-icon-container">
            <PersonIcon className="dashboard-links-icon" />
          </div>
          {isSideBarExpanded && <span>Account Info</span>}
        </NavLink>
      </div>
      {/* Help */}
      <div className="dashboard-links-section">
        {isSideBarExpanded && (
          <span className="dashboard-links-section-title">Help</span>
        )}
        {/* Contact Us */}

        <NavLink to="/contact" className="dashboard-links-section-item">
          <div className="dashboard-links-icon-container">
            <DraftsIcon className="dashboard-links-icon" />
          </div>
          {isSideBarExpanded && <span>Contact Support</span>}
        </NavLink>
      </div>
    </div>
  );
};

export default DashboardLinks;
